<template>
	<b-container class="show-document">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}
				</b-button>
			</div>
			<div class="pull-right">
				<b-button
					variant="outline-primary"
					@click="excelExport('whDocTable', itemObject.regNumber)"
					class="mr-2"
				>
					{{ $t('excel-export.download-excel') }}
				</b-button>
				<!--<b-button-->
				<!--variant="outline-dark"-->
				<!--@click="generateBarcode"-->
				<!--class="mr-2"-->
				<!--v-if="item.action === 'KIRIM'"-->
				<!--&gt;-->
				<!--<i class="fa fa-print"></i>-->
				<!--{{$t('pricing.print')}} {{$t('goods.barcode')}}-->
				<!--</b-button>-->
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{$t('pricing.print')}}
				</b-button>
				<b-button
					v-if="itemObject.editable"
					@click="openSidebar"
					variant="outline-dark"
					class="mr-2"
				>
					<i class="fa fa-edit"></i>
					{{ $t('Изменить') }}
				</b-button>

			</div>
			<div class="clearfix"></div>

		</div>
		<div class="doc-body">
			<b-card class="p-3">
				<b-row class="mb-3">
					<b-col></b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center day-wrapper">
							{{formatDate(itemObject.regDate, 'DD')}}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center ">
							{{formatDate(itemObject.regDate, 'MM')}}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center">
							{{formatDate(itemObject.regDate, 'YYYY')}}
						</div>
					</b-col>
				</b-row>
				<div class="text-center">
					<h3 class="font-weight-bold text-uppercase">{{$t(itemObject.departmentName)}} №: <span class="small">{{itemObject.regNumber}}</span>
					</h3>
				</div>
				<div class="text-right">
					<p>
						<strong>{{$t('incomes.create.to-warehouse')}}:</strong> {{itemObject.toDepartmentName}}
					</p>
				</div>
				<div class="generalTableClass documentItems">
					<table class="table table-striped" id="whDocTable">
						<thead>
						<tr>
							<th> №</th>
							<th>{{$t('goods.artikul')}}</th>
							<th>{{$t('goods.color')}}</th>
							<th>{{$t('incomes.create.product')}}</th>
							<th>{{$t('comment')}}</th>
							<th style="text-align: center">{{$t('incomes.create.count')}}</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="item,index in this.itemObject.requestItem">
							<td>{{index+1}}</td>
							<td>{{item.artikul}}</td>
							<td>{{item.color}}</td>
							<td>{{item.itemName}}</td>
							<td>{{item.comment}}</td>
							<td style="text-align: center">{{item.count}}</td>
						</tr>
						</tbody>
					</table>
				</div>

			</b-card>
		</div>

	</b-container>

</template>

<script>
	import WhDocument from "../../../services/wh-document.service";
	import moment from 'moment'

	export default {
		name: "RequestDocumentShow",
		data() {
			return {
				itemObject: {},
				loader: false,
			}
		},
		methods: {
			excelExport(tableID, filename = '') {

				let downloadLink;

				let dataType = 'text/xls;charset=UTF-8';
				//var dataType = 'application/vnd.ms-excel';
				let tableSelect = document.getElementById(tableID);
				let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

				// Specify file name
				filename = filename.length > 0 ? filename + '.xls' : 'excel_data.xls';
				// Create download link element
				downloadLink = document.createElement("a");

				document.body.appendChild(downloadLink);

				if (navigator.msSaveOrOpenBlob) {
					let blob = new Blob(['\ufeff', tableSelect], {
						encoding: "utf-8",
						type: dataType
					});
					navigator.msSaveOrOpenBlob(blob, filename);
				} else {
					// Create a link to the file
					downloadLink.href = 'data:' + dataType + ', ' +  tableHTML;

					// Setting the file name
					downloadLink.download = filename;

					//triggering the function
					downloadLink.click();
				}

			},
			formatDate(date, format = 'DD-MM-YYYY') {
				if (date) {
					const split = date.split(' ');
					date = split[0];
					const revers = date.split('-');
					date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
					return moment(String(date)).format(format)
				}
			},
			goBackToFrom() {
				this.$router.back();
			},
			print() {
				window.print();
			},
			get() {
				// this.loader = true;
				return WhDocument.getRequestById(this.$route.params.id).then(response => {
					// this.loader = false;
					this.itemObject = response.data;
					// this.sumPrice(this.item);
					// this.sumIncome(this.item);
				}).catch(error => {
					// this.loader = false
				})
			}
		},
		mounted() {
			this.get();
		}

	}
</script>

<style scoped lang="scss">

@page  {
	margin: 1cm;
}

	@media print {
		.hidden-print {
			display: none;
		}

		.card {
			box-shadow: none;
		}
	}

	.generalTableClass {
	.table {
	td, th {
		font-size: 12px;
	}
	}
	}
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
